(function () {
  /* 移动端(≤749）：产品列表默认只显示 8 个(4 行×2)，点一次 "Load More" 再 +8。
     已加载的卡片直接显示(渐进展开)；不够时才 AJAX 拉下一页再展开。桌面端保持原逻辑(整页追加)。 */
  var MOBILE_BATCH = 8;
  function isMobile() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function setup(root) {
    if (!(root instanceof HTMLElement) || root.__pcolInited) return;
    root.__pcolInited = true;

    /* ---------- Sort dropdown: close on outside click / Esc ---------- */
    var sort = root.querySelector("[data-pcol-sort]");
    if (sort) {
      document.addEventListener("click", function (e) {
        if (sort.open && !sort.contains(e.target)) sort.open = false;
      });
      sort.addEventListener("keydown", function (e) {
        if (e.key === "Escape") sort.open = false;
      });
    }

    /* 心形收藏逻辑统一由全站 parans-wishlist.js 委托处理。 */

    /* ---------- Load more ---------- */
    var grid = root.querySelector("[data-pcol-grid]");
    var more = root.querySelector("[data-pcol-more]");
    if (!grid) return;

    /* 0708用户:记录「已加载批次 + 滚动位置」到 sessionStorage(不改 URL;
       不用 history.state —— 站上有第三方脚本会 replaceState 清参数,把 state 抹成 {})。
       从产品页返回、页面被重新加载只剩第1批时,自动补载之前的批次并滚回原位置。 */
    root.__pcolPages = 1;
    function stateKey() {
      var sort = "";
      try { sort = new URLSearchParams(window.location.search).get("sort_by") || ""; } catch (err) {}
      return "pcol:" + window.location.pathname + ":" + sort;
    }
    function saveState() {
      try {
        sessionStorage.setItem(stateKey(), JSON.stringify({
          p: root.__pcolPages,
          s: root.__pcolShown || null,
          y: window.scrollY,
          t: Date.now()
        }));
      } catch (err) {}
    }
    /* 点产品卡(任意链接)瞬间保存当前状态 */
    grid.addEventListener("click", function (e) {
      var a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
      if (a) saveState();
    }, true);

    function cards() {
      return grid.querySelectorAll(":scope > .pcol__card");
    }

    function moreWrap(btn) {
      return (btn && (btn.closest(".pcol__more-wrap") || btn)) || null;
    }

    /* AJAX 追加下一页；done(追加数量) */
    function loadNextPage(btn, done) {
      var url = btn.getAttribute("data-next-url") || btn.getAttribute("href");
      if (!url || btn.classList.contains("is-loading")) {
        if (done) done(0);
        return;
      }
      btn.classList.add("is-loading");
      fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var newCards = doc.querySelectorAll("[data-pcol-grid] > .pcol__card");
          /* 0708用户:追加时锁定滚动位置 —— 新卡插到按钮上方后,浏览器的"滚动锚定"
             会跟着按钮往下带,把视口甩到最底;先记录 scrollY,插完原样恢复。 */
          var keepY = window.scrollY;
          var n = 0;
          newCards.forEach(function (card) {
            grid.appendChild(document.importNode(card, true));
            n++;
          });
          window.scrollTo(0, keepY);
          if (n > 0) { root.__pcolPages++; saveState(); }
          var nextBtn = doc.querySelector("[data-pcol-more]");
          if (nextBtn && nextBtn.getAttribute("data-next-url")) {
            btn.setAttribute("data-next-url", nextBtn.getAttribute("data-next-url"));
            btn.setAttribute("href", nextBtn.getAttribute("href") || nextBtn.getAttribute("data-next-url"));
          } else {
            btn.removeAttribute("data-next-url");
          }
          /* 0708客户点3:不再把地址改写成 ?page=N —— 之前 replaceState 后,从产品页返回
             会加载 /collections/all?page=2 只显示第2页产品。URL 保持不变,追加纯前端进行。 */
          btn.classList.remove("is-loading");
          if (done) done(n);
        })
        .catch(function () {
          btn.classList.remove("is-loading");
          window.location.href = btn.getAttribute("data-next-url") || btn.getAttribute("href");
        });
    }

    /* 移动端：按 __pcolShown 计数,超出的卡片加 --m-hidden 收起;按钮在「还有可展开 或 还有下一页」时显示 */
    function applyMobileVis(btn) {
      var list = cards();
      var shown = root.__pcolShown || MOBILE_BATCH;
      list.forEach(function (c, i) {
        c.classList.toggle("pcol__card--m-hidden", i >= shown);
      });
      grid.classList.add("pcol--js"); /* 关掉 CSS 的 nth-child 初始折叠,交给 --m-hidden */
      var hasNext = !!(btn && btn.getAttribute("data-next-url"));
      var wrap = moreWrap(btn);
      if (wrap) wrap.style.display = list.length > shown || hasNext ? "" : "none";
    }

    function bindMore(btn) {
      if (!btn) return;
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        if (btn.classList.contains("is-loading")) return;

        if (isMobile()) {
          var newShown = (root.__pcolShown || MOBILE_BATCH) + MOBILE_BATCH;
          if (newShown > cards().length && btn.getAttribute("data-next-url")) {
            /* 已加载的不够展开 → 先 AJAX 拉下一页,再展开 */
            loadNextPage(btn, function () {
              root.__pcolShown = newShown;
              applyMobileVis(btn);
            });
          } else {
            /* 已加载的够 → 直接展开下一批 8 个 */
            root.__pcolShown = newShown;
            applyMobileVis(btn);
          }
        } else {
          /* 桌面端：原逻辑,整页 AJAX 追加,没有下一页时移除按钮 */
          loadNextPage(btn, function () {
            if (!btn.getAttribute("data-next-url")) {
              var wrap = btn.closest(".pcol__more-wrap");
              if (wrap) wrap.remove();
              else btn.remove();
            }
          });
        }
      });
    }

    bindMore(more);

    /* 初始：移动端折叠到 8 个 */
    if (more && isMobile()) {
      root.__pcolShown = MOBILE_BATCH;
      applyMobileVis(more);
    }

    /* 0708用户:返回恢复 —— sessionStorage 里有"之前加载到第 N 批"就自动补载回来。
       (bfcache 命中时页面 DOM 原样保留不会重跑到这里,天然无恙;这里处理返回触发重新加载的场景。) */
    (function restoreFromState() {
      var hs = null;
      try { hs = JSON.parse(sessionStorage.getItem(stateKey()) || "null"); } catch (err) {}
      if (!hs || !(hs.p > 1) || !more) return;
      if (hs.t && Date.now() - hs.t > 30 * 60 * 1000) return;   /* 30 分钟过期 */
      /* 接管滚动恢复权:防浏览器原生 scroll restoration 在我们之后把位置盖回顶部/旧值 */
      try { if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual"; } catch (err) {}
      var applyY = function () {
        if (typeof hs.y === "number") window.scrollTo(0, hs.y);
      };
      var finish = function () {
        root.__pcolPages = hs.p;
        if (isMobile()) {
          root.__pcolShown = hs.s || hs.p * MOBILE_BATCH;
          applyMobileVis(more);
        }
        /* 多次校准:图片懒加载/字体会持续撑高布局,晚到的原生恢复也可能抢一手 */
        applyY();
        setTimeout(applyY, 300);
        setTimeout(applyY, 900);
        setTimeout(applyY, 1800);
        if (!more.getAttribute("data-next-url") && !isMobile()) {
          var wrap = more.closest(".pcol__more-wrap");
          if (wrap) wrap.remove();
        }
      };
      (function step(remaining) {
        if (remaining <= 0 || !more.getAttribute("data-next-url")) { finish(); return; }
        loadNextPage(more, function (n) { step(n > 0 ? remaining - 1 : 0); });
      })(hs.p - 1);
    })();

    /* 跨断点切换:进入移动端则按当前计数折叠;回到桌面则全部展开 */
    var mq = window.matchMedia("(max-width: 749px)");
    var onMq = function () {
      if (!more) return;
      if (mq.matches) {
        root.__pcolShown = root.__pcolShown || MOBILE_BATCH;
        applyMobileVis(more);
      } else {
        cards().forEach(function (c) {
          c.classList.remove("pcol__card--m-hidden");
        });
        var wrap = moreWrap(more);
        if (wrap) wrap.style.display = "";
      }
    };
    if (mq.addEventListener) mq.addEventListener("change", onMq);
    else if (mq.addListener) mq.addListener(onMq);
  }

  function initAll(scope) {
    var r = scope instanceof HTMLElement ? scope : document;
    r.querySelectorAll("[data-pcol]").forEach(setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (e.target instanceof HTMLElement) {
      e.target.querySelectorAll("[data-pcol]").forEach(function (n) {
        n.__pcolInited = false;
      });
      initAll(e.target);
    }
  });
})();
